module.exports = __webpack_public_path__ + "static/img/btn_1.bf5a29b8.jpg";